import { FormattedMessage } from 'react-intl';
import Modal from 'react-modal';
import React from 'react';
import Button from './UI/Button';
import SkillBox from './SkillBox';
import SkillModalProps from '../types/ModalProps';
import style from './Modal.module.css';
import {
  renderStrong,
  renderEm,
  renderP,
  renderBr,
} from '../services/renderValues';

Modal.setAppElement('#root');

/**
 * ## Modal with the selected skill displayed.
 * The content is a markdown file.
 * @param {SkillModalProps} props
 * @returns
 */
function CurrentSkillModal({
  modalIsOpen,
  closeModal,
  currentSkill,
}: SkillModalProps) {
  return (
    <Modal
      className={style.modal}
      overlayClassName={style.overlay}
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel="Detail technologie"
    >
      <SkillBox skill={currentSkill} />

      <div className="open-sans-font text-justify" data-testid="modal-content">
        {currentSkill.description ? (
          <FormattedMessage
            id={currentSkill.description}
            values={
              {
                strong: renderStrong,
                em: renderEm,
                p: renderP,
                br: renderBr,
              } as Record<string, any>
            }
          />
        ) : (
          <p className={style.center}>
            Aucune description disponible pour cette technologie.
          </p>
        )}
      </div>
      <Button onClick={closeModal}>
        <FormattedMessage id="close" />
      </Button>
    </Modal>
  );
}

export default CurrentSkillModal;
